declare global {
  interface Window {
    initMap: any;
  }
}
window.initMap = window.initMap || {};

export function init() {

  const consentCookie = getCookie('privacy-consent');
  const consentBlock  = document.querySelector('.consent-block');
  const map           = document.querySelector('#map');

  if (consentCookie == 'no') {

    const button = document.querySelector('.map-consent-button');
    button.addEventListener('click', event => {
      map.classList.remove('hidden');
      consentBlock.classList.add('hidden');
      loadScript();
    });
    return;
  }
  else {
    map.classList.remove('hidden');
    consentBlock.classList.add('hidden');
    loadScript();
  }
}

function loadScript() {
  const element = document.getElementById('map');
  if (!element) return;

  window.initMap = initMap;

  let script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCJMxePsfcqVIkyMYv_XvlEc9dm9YYbxaw&callback=initMap';
  script.async = true;
  document.head.appendChild(script);
}

function initMap() {

  const element = document.getElementById('map');
  
  const position: google.maps.LatLngLiteral = {
    lat: Number(element.dataset.lat),
    lng: Number(element.dataset.lon)
  };

  const mapOptions: google.maps.MapOptions = {
    center: position,
    zoom: 16,
    styles: [
      {featureType: 'all'      , stylers: [{ saturation: -100  }], elementType: 'labels',}, 
      {featureType: 'landscape', stylers: [{ visibility: 'off' }]}, 
      {featureType: 'poi'      , stylers: [{ visibility: 'off' }]}, 
      {featureType: 'water'    , stylers: [{ color:  '#7dcdcd' }]}, 
      {featureType: 'road'     , stylers: [{ color:  '#ffffff' }], elementType: 'geometry'}
    ]
  };

  const map = new google.maps.Map(element, mapOptions);

  const markerOptions: google.maps.MarkerOptions = {
    position: position,
    map: map,
    icon:  {
      anchor: <google.maps.Point> {x: 31, y: 92},
      size: <google.maps.Size> {height: 92, width: 63}, 
      url: '/sites/all/themes/subtheme/src/components/blocks/map/place-red.png'
    }
  }

  const marker = new google.maps.Marker(markerOptions);
}

function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res
}




